import type { Game } from "@/types";
import { getGameEvents, getTeamById } from "@/utils/nba";

interface TimelineFeedProps {
  game: Game;
}

export default function TimelineFeed({ game }: TimelineFeedProps) {
  const events = getGameEvents(game);

  if (game.status === "upcoming") {
    return (
      <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-14 text-center">
        <span className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-background-100 text-foreground-400">
          <i className="ri-time-line text-xl" />
        </span>
        <p className="text-sm text-foreground-500">比赛尚未开始，赛况动态将在开赛后实时更新</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-5 flex items-center justify-between">
        <h3 className="font-heading text-base font-semibold text-foreground-950">赛况动态</h3>
        {game.status === "live" ? (
          <span className="flex items-center gap-1.5 text-xs font-medium text-accent-600">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse-dot" />
            实时更新中
          </span>
        ) : (
          <span className="text-xs text-foreground-400">比赛已结束 · 示例数据</span>
        )}
      </div>

      <div className="relative space-y-4 pl-4">
        <span className="absolute left-0 top-2 bottom-2 w-px bg-background-200" />
        {[...events].reverse().map((event) => {
          const team = getTeamById(event.teamId);
          return (
            <div key={event.id} className="relative">
              <span
                className="absolute -left-4 top-1.5 w-2.5 h-2.5 rounded-full ring-4 ring-background-50"
                style={{ backgroundColor: team?.color ?? "#999" }}
              />
              <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-400">
                <span className="rounded bg-background-100 px-1.5 py-0.5">{event.quarter}</span>
                <span>{event.time}</span>
                <span className="font-medium text-foreground-600">{team?.abbreviation}</span>
              </div>
              <p className="mt-1 text-sm text-foreground-900">
                <span className="font-medium">{event.player}</span>
                <span className="text-foreground-600"> {event.description}</span>
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}